module.exports = __webpack_public_path__ + "img/applink.e473e057.png";